module.exports = __webpack_public_path__ + "static/media/manageimg.5ee47f63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/manageimg.jpg
// module id = 438
// module chunks = 0